import React from "react";
import MainTemplate from "../../../../components/MainTemplate/MainTemplate";
import AdminTimelineSection from "./AdminTimelineSection";

const AdminTimeline = () => {
  return (
    <MainTemplate>
      <AdminTimelineSection />
    </MainTemplate>
  );
};

export default AdminTimeline;
